export default "__VITE_ASSET__DZdlxeBT__"